<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showProduct") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <div class="preview-container text-center my-3">
            <label style="color: #405950; font-size: 16px" class="mt-5">{{
              $t("MESSAGES.Offer image")
            }}</label>
            <br />
            <img
              :src="data.image.path"
              alt="Product Image"
              v-if="data.image.path"
              class="mx-5 my-3 img-thumbnail"
            />
          </div>
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            :value="data.provider.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Offer name arabic')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Offer name english')"
            v-model.trim="data.nameEn"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Offer start date')"
            :value="data.start_date"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Offer end date')"
            :value="data.end_date"
            disabled
          />
          <base-text-editor
            col="6"
            type="time"
            :placeholder="$t('MESSAGES.terms of use arabic')"
            v-model.trim="data.usage_policy_ar"
            disabled
          />
          <base-text-editor
            col="6"
            type="time"
            :placeholder="$t('MESSAGES.terms of use english')"
            v-model.trim="data.usage_policy_en"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.Offer description arabic')"
            v-model.trim="data.descProd"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.Offer description english')"
            v-model.trim="data.descProdEn"
            disabled
          />

          <div class="col-12 my-3" v-if="clients.length">
            <label class="form-label d-block mb-3">
              {{ $t("PLACEHOLDERS.clients_menu") }}
            </label>
            <div class="clients_list">
              <div
                v-for="client in clients"
                :key="client.id"
                class="clients_list__item"
              >
                <span class="clients_list__name">{{ client.name }}</span>
                <span class="clients_list__phone" dir="ltr">
                  {{ formatClientPhone(client) }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-12">
            <gmap-map
              :center="{
                lat: data.lat ?? 24.7136,
                lng: data.lng ?? 46.6753,
              }"
              :zoom="6"
              style="width: 100%; height: 300px"
            >
              <gmap-marker
                v-if="data.lat && data.lng"
                :position="{
                  lat: data.lat,
                  lng: data.lng,
                }"
              />
            </gmap-map>
          </div>
          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <template>
      <!-- Start:: Image Modal -->
      <image-modal
        v-if="dialogImage"
        :type="selectedItemType"
        :modalIsOpen="dialogImage"
        :modalImage="selectedItemImage"
        @toggleModal="dialogImage = !dialogImage"
      />
    </template>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ShowProduct",

  data() {
    return {
      dialogImage: false,
      selectedItemImage: null,
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      AddimgUrls: [],
      clients: [],

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        provider: null,
        lat: null,
        lng: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        price: null,
        product_category_id: null,
        start_date: null,
        end_date: null,
        quantity: null,
        created_at: null,
        usage_policy_ar: null,
        usage_policy_en: null,
        active: null,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    showImageModal(item) {
      this.dialogImage = true;
      this.selectedItemImage = item;
      this.selectedItemType = item.endsWith("mp4") ? "video" : "image";
    },

    formatClientPhone(client) {
      const mobile = String(client?.mobile || "").trim();
      if (!mobile) return "-";

      const code = String(client?.country_code || "").trim();
      return code ? `${code} ${mobile}` : mobile;
    },

    mapOfferClients(clients) {
      return (clients || []).map((client) => ({
        id: client.user?.id || client.id,
        name: client.user?.name || client.name || "-",
        country_code: client.user?.country_code || client.country_code || "",
        mobile: client.user?.mobile || client.mobile || "",
      }));
    },

    // start show data
    async showProduct() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `offers/${this.$route.params.id}`,
        });
        const offer = res.data.data.Offer;

        this.data.image.path = offer.image;
        this.data.provider = offer.provider;
        this.data.name = offer.name_ar;
        this.data.nameEn = offer.name_en;
        this.data.descProd = offer.description_ar;
        this.data.descProdEn = offer.description_en;
        this.data.start_date = offer.start_date;
        this.data.end_date = offer.end_date;
        this.data.usage_policy_ar = offer.privacy_ar;
        this.data.usage_policy_en = offer.privacy_en;
        this.data.lat = offer.lat;
        this.data.lng = offer.lng;
        this.data.active = offer.is_active;
        this.clients = this.mapOfferClients(offer.clients);
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    // Start:: Fire Methods
    this.showProduct();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
}

.clients_list {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  max-height: 240px;
  overflow-x: hidden;
  overflow-y: auto;
}

.clients_list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.clients_list__item:last-child {
  border-bottom: none;
}

.clients_list__name {
  color: #405950;
  font-weight: 600;
}

.clients_list__phone {
  color: #666;
  white-space: nowrap;
}
</style>
